import React from 'react';

export default function ConsentModalSch({ onCancel, onAccept }) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white rounded shadow-lg w-full max-w-3xl p-6 relative">
        {/* โลโก้ Charles Schwab อยู่มุมซ้ายบน */}
       
        
        <h3 className="text-lg font-semibold mb-4">Instruction and Informed Consent</h3>
        <p className="mb-6">
          By continuing, you are instructing Schwab to grant access to your account information to your designated, authorized Quantum Flo Auto Algo.
        </p>
        <div className="flex justify-end gap-4">
          <button
            onClick={onCancel}
            className="py-2 px-4 border rounded hover:bg-gray-100"
          >
            Cancel
          </button>
          <button
            onClick={onAccept}
            className="py-2 px-4 bg-green-600 text-white rounded hover:bg-green-700"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
